import './index.scss'

const ContactPage = () => {
  return (
    <main className="contact-page">
      <div className="site-container">
      <section className="contact-hero">
        <div className="contact-hero__content">
          <p className="eyebrow">Contact</p>
          <h1>Get in touch</h1>
          <h2>Open to graduate opportunities in software engineering and technology</h2>
          <p>
            I am keen to connect about graduate roles, technical projects, and opportunities where I can continue building impactful software.
          </p>
        </div>
      </section>

      <section className="contact-grid">
        <article className="contact-card">
          <h3>Email</h3>
          <a href="mailto:christianturner528@gmail.com">christianturner528@gmail.com</a>
        </article>

        <article className="contact-card">
          <h3>LinkedIn</h3>
          <a href="https://www.linkedin.com/in/christian-turner-jones-785390319/" target="_blank" rel="noreferrer">linkedin.com/in/christian-turner-jones</a>
        </article>

        <article className="contact-card">
          <h3>GitHub</h3>
          <a href="https://github.com/cxt338" target="_blank" rel="noreferrer">github.com/cxt338</a>
        </article>
      </section>
      </div>
    </main>
  )
}

export default ContactPage
